import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const QcReportsLayout = lazy(() => import('@/pages/qcReports/layout'));
const QcReportsListPage = lazy(() => import('@/pages/qcReports'));
const QcReportViewPage = lazy(() => import('@/pages/qcReports/view'));

/**
 * UG-4504 — quality-control response routes (legacy `app/(dashboard)/qc-reports/*`).
 * `QcReportsLayout` mounts the section breadcrumb. Permissions:
 * `@/config/auth/routeAccess` (both paths under `qcResponse.view`, ported 1:1
 * from the legacy table). The job-scoped `/jobs/:jobId/qc-reports` page lives
 * in the jobs group (job detail shell); the per-client template editor in the
 * clients group.
 */
export const qcReportRoutes: RouteConfig = {
  path: '/qc-reports',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: QcReportsLayout,
      children: [
        { path: '', element: QcReportsListPage },
        { path: '/:qcId/view', element: QcReportViewPage },
      ],
    },
  ],
};
